module.exports = __webpack_public_path__ + "img/656.c2f474a5.png";